// src/ui/utils/sliceMessagesUntil.tsx
var sliceMessagesUntil = (messages, messageId) => {
  if (messageId == null) return [];
  let messageIdx = messages.findIndex((m) => m.id === messageId);
  if (messageIdx === -1)
    throw new Error(
      "useVercelAIThreadState: Message not found. This is liekly an internal bug in assistant-ui."
    );
  while (messages[messageIdx + 1]?.role === "assistant") {
    messageIdx++;
  }
  return messages.slice(0, messageIdx + 1);
};
export {
  sliceMessagesUntil
};
//# sourceMappingURL=sliceMessagesUntil.js.map